export default __webpack_public_path__ + "static/media/proximanova-medium.908fc77d.WOFF";